import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GridApi, ColDef, ExcelExportParams, GridOptions } from 'ag-grid-community';
import { HygineReportService } from '../hygine-report.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { HygineReportDialogComponent } from '../hygine-report-dialog/hygine-report-dialog.component';

@Component({
  selector: 'app-hygine-report',
  templateUrl: './hygine-report.component.html',
  styleUrls: ['./hygine-report.component.scss']
})
export class HygineReportComponent implements OnInit {
  hyginedata: any;
  constructor(private hygine:HygineReportService,private dialog: NgDialogAnimationService){}
   public rowData: any[] = []; 
   selectedRowIndex: number | null = null;
    @ViewChild('gridContainer') gridContainer!: ElementRef;
  columnDefs: ColDef[] = [
    { headerName: 'City', field: 'cityName', sortable: true, filter: true,   cellStyle: { cursor: 'pointer', 'font-size': '12px' }  },
    { headerName: 'Campus', field: 'campusName', sortable: true, filter: true , cellStyle: { cursor: 'pointer', 'font-size': '12px' } },
    { headerName: 'Building', field: 'buildingName', sortable: true, filter: true,  cellStyle: { cursor: 'pointer', 'font-size': '12px' } },
    { headerName: 'Block', field: 'blockName' ,sortable: true, filter: true ,  cellStyle: { cursor: 'pointer', 'font-size': '12px' } },
    { headerName: 'Floor', field: 'floorNumber', sortable: true, filter: true,cellStyle: { cursor: 'pointer', 'font-size': '12px' } },
    { headerName: 'Room No', field: 'roomNo', sortable: true, filter: true,cellStyle: { cursor: 'pointer', 'font-size': '12px' }  },
    { headerName: 'Activity', field: 'activityName', sortable: true, filter: true,cellStyle: { cursor: 'pointer', 'font-size': '12px' }  },
    { headerName: 'Created On', field: 'createdOn', sortable: true, filter: true,cellStyle: { cursor: 'pointer', 'font-size': '12px' }  },
    { headerName: 'User Name', field: 'userName', sortable: true, filter: true ,cellStyle: { cursor: 'pointer', 'font-size': '12px' } },
    { headerName: 'Designation', field: 'designation', sortable: true, filter: true , cellStyle: { cursor: 'pointer', 'font-size': '12px' } }
    
  ];
    defaultExcelExportParams: ExcelExportParams = {
      exportAsExcelTable: true,
    };
  ngOnInit(): void {
  
  
    this.loadHygineData();
  }

   private gridApi!: GridApi<any>;
     quickFilter: string = ''
  onBtExport() {
    this.gridApi.exportDataAsExcel({
      fileName: 'hygineReport',
      sheetName: 'hygineReport'
    });
    alert("Execl Report genarated Please check the Download List")
  }

  loadHygineData() {
    this.hygine.gethyginelist().subscribe({
      next: (res: any) => {
        this.rowData = res;   
      },
      error: (err) => {
        console.error('Error fetching hygine data', err);
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
      this.adjustGridHeight();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }
    onRowClicked(event: any) {
        this.selectedRowIndex = event.rowIndex; 
    const campusName = event.data.campusName; 
    const selectedNodes = this.gridApi.getSelectedNodes();
    
    this.dialog.open(HygineReportDialogComponent, {
     width: '40%',
      height: '100%',
      panelClass: ['custom-dialog-panel'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      disableClose: false,
      // hasBackdrop: false,
     data: event.data 
    });
  }
  gridOptions: GridOptions = {
  rowHeight: 25,
  headerHeight: 30,
  domLayout: 'autoHeight' 

};
adjustGridHeight() {
   if (!this.gridApi) return;

    const rowCount = this.gridApi.getDisplayedRowCount();
    const headerHeight = 30; 
    const rowHeight = 25;    
    const paginationPanelHeight = 50;

    const totalHeight = headerHeight + rowCount * rowHeight + paginationPanelHeight;

    const gridElement = document.querySelector('.ag-theme-alpine') as HTMLElement;
    if (gridElement) {
      gridElement.style.height = `${Math.min(totalHeight, 600)}px`; 
    }
    this.gridApi.sizeColumnsToFit();
  }
  

onRowDataChanged() {
  this.adjustGridHeight();
}
}
